import React, { useRef, useState, useEffect, memo } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { showModal } from '@store/actions/commonAction';
import SatModal from '@components/common/satUI/SatModal';
import { PRODUCT_COMP_CD } from '@common/constants';

const ManagementSystemCodePop = props => {
  const { isOpen, data, onClose, onSave, isModify = false } = props;
  const dispatch = useDispatch();
  const [codeInfo, setCodeInfo] = useState({
    compCd: PRODUCT_COMP_CD.cm, // 회사정보
    cdTyId: '', // 그룹코드
    cdTyNm: '', // 그룹코드명
    cdTyDsc: '', // 그룹코드 설명
    fstRegDdtm: '', // 일시
    fstRegerEmpno: '', // ID
    upCdTyId: '', // 참조한 그룹코드 유형
  });

  useEffect(() => {
    setCodeInfo({
      compCd: data.compCd,
      cdTyId: data.cdTyId,
      cdTyNm: data.cdTyNm,
      cdTyDsc: data.cdTyDsc,
      fstRegDdtm: data.fstRegDdtm,
      fstRegerEmpno: data.fstRegerEmpno,
      upCdTyId: data.upCdTyId,
    });
  }, [data]);
  const onChangeHandler = e => {
    const { name, value } = e.target;

    setCodeInfo({
      ...codeInfo,
      [name]: value,
    });
  };
  const onKeyupHandler = e => {
    const { value, name } = e.target;

    setCodeInfo({
      ...codeInfo,
      [name]: value.replace(/[^0-9.]/g, ''),
    });
  };

  const onSaveHandler = () => {
    const { compCd, cdTyId, cdTyNm } = codeInfo;
    if (compCd.trim() === '' || cdTyId.trim() === '' || cdTyNm.trim() === '') {
      dispatch(
        showModal({
          visible: true,
          type: 'info',
          msg: '필수값 입력을 확인해주세요.',
        }),
      );
      return;
    }
    onSave(codeInfo);
  };
  return (
    <>
      <SatModal visible={isOpen} type="newInfo">
        <h3 className="layer-tit2">그룹코드 등록/수정</h3>
        <div className="cont">
          <div className="modal-tbl">
            <table className="tbl-sty2">
              <colgroup>
                <col width="25%;" />
                <col width="75%;" />
              </colgroup>
              <tbody>
                <tr>
                  <th>회사정보</th>
                  <td>
                    <div className="check-box w100">
                      <div className="check-wrap">
                        <input
                          type="radio"
                          name="compCd"
                          id="info1"
                          checked={
                            codeInfo.compCd === '' ||
                            codeInfo.compCd === PRODUCT_COMP_CD.cm
                          }
                          value={PRODUCT_COMP_CD.cm}
                          onChange={onChangeHandler}
                        />
                        <label htmlFor="info1">통합</label>
                      </div>
                      <div className="check-wrap">
                        <input
                          type="radio"
                          name="compCd"
                          id="info2"
                          checked={codeInfo.compCd === PRODUCT_COMP_CD.kb}
                          value={PRODUCT_COMP_CD.kb}
                          onChange={onChangeHandler}
                        />
                        <label htmlFor="info2">구.KB생명</label>
                      </div>
                      <div className="check-wrap">
                        <input
                          type="radio"
                          name="compCd"
                          id="info3"
                          checked={codeInfo.compCd === PRODUCT_COMP_CD.pr}
                          value={PRODUCT_COMP_CD.pr}
                          onChange={onChangeHandler}
                        />
                        <label htmlFor="info3">구.푸르덴셜</label>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>그룹코드 유형</th>
                  <td>
                    <div className="input-wrap">
                      <div className="input-area">
                        <input
                          type="text"
                          name="cdTyId"
                          id="code-01"
                          placeholder="그룹코드 유형을 입력하세요."
                          value={codeInfo.cdTyId}
                          onChange={onChangeHandler}
                          disabled={isModify}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>그룹코드명</th>
                  <td>
                    <div className="input-wrap">
                      <div className="input-area">
                        <input
                          type="text"
                          name="cdTyNm"
                          id="code-02"
                          placeholder="그룹코드명을 입력하세요."
                          value={codeInfo.cdTyNm}
                          onChange={onChangeHandler}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>그룹코드 설명</th>
                  <td>
                    <div className="input-wrap">
                      <div className="input-area">
                        <input
                          type="text"
                          name="cdTyDsc"
                          id="code-03"
                          placeholder="그룹코드 설명을 입력하세요."
                          value={codeInfo.cdTyDsc}
                          onChange={onChangeHandler}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>참조한 그룹코드 유형</th>
                  <td>
                    <div className="input-wrap">
                      <div className="input-area">
                        <input
                          type="text"
                          pattern="[0-9]*"
                          name="upCdTyId"
                          id="code-04"
                          placeholder="참조한 그룹코드 유형을 입력하세요."
                          value={
                            codeInfo.upCdTyId === null ? '' : codeInfo.upCdTyId
                          }
                          onChange={onChangeHandler}
                          onKeyUp={onKeyupHandler}
                        />
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <th>등록/수정일시</th>
                  <td>
                    <span className="txt">{codeInfo.fstRegDdtm}</span>
                  </td>
                </tr>
                <tr>
                  <th>등록/수정ID</th>
                  <td>
                    <span className="txt">{codeInfo.fstRegerEmpno}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div className="layer-footer">
          <button className="btn-l btn-save" onClick={() => onSaveHandler()}>
            저장
          </button>
        </div>
        <button className="btn-layer-close modal-close" onClick={onClose}>
          창닫기
        </button>
      </SatModal>
    </>
  );
};

export default memo(ManagementSystemCodePop);
